import {Card, CardContent} from '@mui/material';
import {DataGrid, GridColDef} from '@mui/x-data-grid';
import {useDataGrid} from '@refinedev/mui';
import {DateTime} from 'luxon';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router';

import {fromPhpDate} from '@app/helpers/from-php-date';
import {List} from '@components/crud/list';

import {User} from './user-types';

const ListUsers = () => {
  const {t} = useTranslation();
  const {dataGridProps} = useDataGrid<User>({
    syncWithLocation: true,
  });

  const REACHFIVE_CONSOLE = import.meta.env.VITE_REACHFIVE_CONSOLE;

  const {rowCount, ...cleanDataGridProps} = dataGridProps;

  const columns = useMemo<GridColDef<User>[]>(
    () => [
      {
        field: 'fullName',
        headerName: t('pages.pilotage-rh.user.fields.name'),
        flex: 1,
        valueGetter: (value, row) => {
          return `${row.firstName || ''} ${row.lastName || ''}`;
        },
      },
      {
        field: 'email',
        headerName: t('pages.pilotage-rh.user.fields.email'),
        flex: 1,
      },
      {
        field: 'lastLogin',
        headerName: t('pages.pilotage-rh.user.fields.lastLogin'),
        flex: 1,
        renderCell: ({row}) =>
          row.lastLogin ? fromPhpDate(row.lastLogin).toLocaleString(DateTime.DATETIME_SHORT) : '-',
      },

      {
        field: 'account',
        headerName: t('pages.pilotage-rh.user.fields.account'),
        valueGetter: (value, row) => {
          return row.account?.label;
        },
        flex: 1,
        renderCell: ({row}) =>
          row.account && row.account.uuid ? (
            <Link to={`/pilotage-rh/accounts/edit/${row.account.uuid}`}>{row.account.label}</Link>
          ) : (
            'pas de compte'
          ),
      },

      {
        field: 'reachfive',
        headerName: t('pages.pilotage-rh.user.fields.reachfive'),
        flex: 1,
        renderCell: ({row}) =>
          row.reachfive ? (
            <Link to={`${REACHFIVE_CONSOLE}/profile/${row.reachfive}`} target="_blank">
              {row.reachfive}
            </Link>
          ) : (
            '-'
          ),
      },
    ],
    [t],
  );

  return (
    <List>
      <Card>
        <CardContent sx={{padding: 0}}>
          <DataGrid
            {...cleanDataGridProps}
            columns={columns}
            paginationMode={'client'}
            sortingMode={'client'}
            filterMode={'client'}
            getRowId={(row) => row.uuid}
          />
        </CardContent>
      </Card>
    </List>
  );
};

export default ListUsers;
